import { RxStomp } from '@stomp/rx-stomp';
import { environment } from '@environments/environment';

export function rxStompFactory() {
    const rxStomp = new RxStomp();
    rxStomp.configure({
        brokerURL: environment.wsBrokerUrl,
        heartbeatIncoming: 20000,
        heartbeatOutgoing: 20000,
        reconnectDelay: 5000,
    });
    return rxStomp;
}